import ProfilesList from "./ProfilesList";
import BannerSearchBar from "./BannerSearchBar";
import Header from "../landingSections/header/Header";
import Footer from "../landingSections/footer/Footer";
import { useLocation } from "react-router-dom";
import SearchProfileHeader from "../landingSections/header/SearchProfileHeader";
import SearchProfileFooter from "../landingSections/footer/SearchProfileFooter";
import { useState } from "react";

const SearchProfiles = () => {
  const location = useLocation();
  const stateParams = location.state;
  const params = new URLSearchParams(location.search);
  const queryRole = params.get("role");
  const queryCity = params.get("city");
  const queryListingType = params.get("listing_type");
  const queryPropertyType = params.get("property_type");
  const queryStatus = params.get("property_status");
  const queryAdvance = params.get("advance");

  const queryUrlData = {
    role: queryRole,
    city: queryCity,
    listingType: queryListingType,
    propertyType: queryPropertyType,
    propertyStatus: queryStatus,
    advance: queryAdvance,
  };

  const [selectedCity, setSelectedCity] = useState(stateParams?.city);
  const [selectedDistrict, setSelectedDistrict] = useState(
    stateParams?.district
  );
  const [selectedRole, setSelectedRole] = useState(stateParams?.role);

  const [selectedListingType, setSelectedListingType] = useState(stateParams?.listingType);
  const [selectedPropertyType, setSelectedPropertyType] = useState(stateParams?.propertyType);
  const [selectedPropertyStatus, setSelectedPropertyStatus] = useState(stateParams?.propertyStatus);

  return (
    <div>
      <SearchProfileHeader
        btnLabel="get_searched_with_us"
        btnUrl="/professionals"
      />
      <BannerSearchBar
        selectedData={stateParams}
        selectedCity={selectedCity}
        setSelectedCity={setSelectedCity}
        selectedRole={selectedRole}
        setSelectedRole={setSelectedRole}
        selectedDistrict={selectedDistrict}
        setSelectedDistrict={setSelectedDistrict}
        selectedListingType={selectedListingType}
        setSelectedListingType={setSelectedListingType}
        selectedPropertyType={selectedPropertyType}
        setSelectedPropertyType={setSelectedPropertyType}
        selectedPropertyStatus={selectedPropertyStatus}
        setSelectedPropertyStatus={setSelectedPropertyStatus}
        queryData={queryUrlData}
      />
      <ProfilesList selectedCity={selectedCity} queryData={queryUrlData} />
      <SearchProfileFooter />
    </div>
  );
};

export default SearchProfiles;
